import { BASE_URL } from "../../config";
import { RESET_STATUS_STATE, REQUEST_STATE, SET_SUCCESS_STATE, SET_ERROR_STATE } from "../../utils/constants/actionTypes";
import { ALoan, ULoan } from "../../config/api";
import bugsnagClient from "../../config/bugsnag";
import { asyncLoanDetail } from "./LoanDetail";
import Loan from "./Loan";

export const PostDrafPinjaman = (ClientID, data, id, cb) => async (dispatch) => {
	dispatch({ type: RESET_STATUS_STATE });
	dispatch({ type: REQUEST_STATE });

	let method, url;
	if (id) {
		method = "PATCH";
		url = ULoan(id);
	} else {
		method = "POST";
		url = ALoan;
	}
	console.log("send to api === ", { data });

	try {
		let res = await fetch(`${BASE_URL}${url}`, {
			method: method,
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ loan: data }),
		});

		let hasil = await res.json();
		if (res.status === 200 || res.status === 201) {
			cb({ isError: false, loanCode: hasil.result.loan.loanCode });
			dispatch(asyncLoanDetail(ClientID, hasil.result.loan.loanCode));
			dispatch({ type: SET_SUCCESS_STATE, payload: hasil.status.message });

			console.log("Berhasil", hasil.status.message);
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			cb({ isError: true });

			console.log("Gagal", hasil.status.message);
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		cb({ isError: true });
	}
};

export const SubmitPinjaman = (ClientID, id, cb) => async (dispatch) => {
	dispatch({ type: RESET_STATUS_STATE });
	dispatch({ type: REQUEST_STATE });

	try {
		let res = await fetch(`${BASE_URL}/loan/invoice-financing/${id}/submit`, {
			method: "POST",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
				"Content-Type": "application/json",
			},
		});

		let hasil = await res.json();
		if (res.status === 200 || res.status === 201) {
			cb({ isError: false });
			dispatch({ type: SET_SUCCESS_STATE, payload: hasil.status.message });

			console.log("Berhasil", hasil.status.message);
		} else {
			bugsnagClient.notify(new Error(`DraftPinjaman.js/PostDrafPinjaman (line 40) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			cb({ isError: true });

			console.log("Gagal", hasil.status.message);
		}
	} catch (err) {
		bugsnagClient.notify(new Error(`DraftPinjaman.js/PostDrafPinjaman (line 47) ===> catch - ${err.message}`));
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		cb({ isError: true });
	}
};

export const DeleteDrafPinjaman =
	(ClientID, id, memo = null) =>
	async (dispatch) => {
		dispatch({ type: RESET_STATUS_STATE });
		dispatch({ type: REQUEST_STATE });

		try {
			let res = await fetch(`${BASE_URL}/loan/invoice-financing/${id}/discard`, {
				method: "POST",
				credentials: "include",
				headers: {
					"X-Client-ID": ClientID,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ loan: { memo: !memo ? "Delete Draf Pinjaman" : memo } }),
			});

			let hasil = await res.json();
			if (res.status === 200 || res.status === 201) {
				dispatch(Loan(ClientID, ["DF1"]));
				dispatch({ type: SET_SUCCESS_STATE, payload: hasil.status.message });

				console.log("Berhasil", hasil.status.message);
			} else {
				dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });

				console.log("Gagal", hasil.status.message);
			}
		} catch (err) {
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
		}
	};
